export default __webpack_public_path__ + "static/media/Corpay x Alpha LockUp_French - Corporate - Horizontal - White.d291f64c.svg";